import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "A two-way loudspeaker system is filtered using a second-order Linkwitz-Riley passive crossover. A resistor R<sub>l</sub> is inserted in series before the tweeter crossover to adjust the high frequency response.  Play with the cut-off frequency f<sub>c</sub> and the resistor R<sub>l</sub> to see their effect on the frequency response. You can also choose to click on the tweeter's polarity inversion switch and see what happens in the crossover region.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0423/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
